import { connectRefinementList } from "react-instantsearch-dom";
import React, { useState, useEffect } from "react";

//--------------------------CheckBox Filter For Category,Sub-Category--------------(MULTI-SELECT INPUT)--------------------------------

const ConnectedCustomRefinementListnewLogic = ({
  attribute,
  items,
  refine,
  title,
  currentRefinement,
  setIndustryCheckBoxValue,
  CategoryCheckBoxValue,
  setCategoryCheckBoxValue,
  filterConfigurations,
  setIsGridView,
  setIsPriceSelected,
  setIsIndustrySelected,
  setIsCategorySelected,
  setIsBrandsSelected,
  setIsModelSelected,
  setIsLocationSelected,
  updateItemsCount,
  updateFacetsAndMakeAPICall
}) => {
  useEffect(() => {
    // console.log(`Title: ${title}, Attribute: ${attribute}`);
    // console.log(`Items for ${title}:`, items);
    // console.log(`Item count: ${items.length}`);

    // Update item count in FilterSection when items change
    updateItemsCount(title, items.length);
  }, [items.length, title]);


useEffect(() => {
   
    updateItemsCount(title, items.length);

   
    // console.log("filterConfigurations updated:", filterConfigurations);

   
    if (filterConfigurations.length > 0) {
      // Refresh items or attributes logic here (for now, just logging it)
    //   console.log("Refreshing items and attributes based on filterConfigurations");
    //   console.log("Updated items:", items);
    //   console.log("Updated attribute:", attribute);

      // You can also refresh state or other values if needed
    }
  }, [filterConfigurations]);

  // console.log('attribute---->', attribute);
  // console.log('items :: ', items);
  const regex = /.*?>\s*/g;
  const [selectedValues, setSelectedValues] = useState([]);
  const [visibleItemsCount, setVisibleItemsCount] = useState(4);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleCheckboxChange = (event,searchState) => {
    // console.log("Clicking this : ");
    const value = event.currentTarget.value;
    const newSelectedValues = [...selectedValues];

    // console.log(
    //   `CheckBox changed : ${value} , Checked : ${event.currentTarget.checked}`
    // );

    //industry
    if (event.target.id === "categories.lvl0") {
      // console.log("Now industry is being clicked");
      setIndustryCheckBoxValue(newSelectedValues);
      setIsIndustrySelected(true);
    }

    //brands
    if (event.target.id === "attributes.Brands") {
      // console.log("Now brands is being selected");
      setIsBrandsSelected(true);
    }

    //Model
    if (event.target.id === "attributes.Model") {
      // console.log("Now model is being selected");
      setIsModelSelected(true);
    }

    //Location
    if (event.target.id === "attributes.Machine Location") {
      // console.log("Now Location is selected");
      setIsLocationSelected(true);
    }

    //category
    // if (attribute === "categories.lvl1") {
    //   console.log("Categoreies is checked");
    //   const isChecked = event.currentTarget.checked;
    //   const newValue = isChecked ? [value] : [];
    //   // console.log("newValue : ", newValue);
    //   setCategoryCheckBoxValue(newValue);
    //   setIsCategorySelected(true);
    //   refine(newValue);
    //   return;
    // }

    // Handle category selection
    if (attribute === "categories.lvl1") {
      // console.log("Now new category selection is being clicked : ");
      const isChecked = event.currentTarget.checked;

      if (isChecked) {
        // Add selected category to the list
        // console.log("category value : ",value);
        newSelectedValues.push(value);
      } else {
        // Remove unselected category from the list
        const index = newSelectedValues.indexOf(value);
        if (index !== -1) {
          newSelectedValues.splice(index, 1);
        }
      }

      // Update the state with selected categories
      setCategoryCheckBoxValue(newSelectedValues);
      setIsCategorySelected(newSelectedValues.length > 0); // This will track if any category is selected

      // Refine the results based on the selected categories
      refine(newSelectedValues);
    }

    if (event.target.id === "categories.lvl1") {
      // console.log("categories.lvl1 - HealthCare part");
      if (event.currentTarget.checked) {
        // console.log("HealthCare is displaying:");
        setCategoryCheckBoxValue([value]);
        setIsCategorySelected(true);
        refine(value);
        return;
      } else {
        // console.log("Removing from 'categories.lvl1':", value);
        setCategoryCheckBoxValue([]);
        setIsCategorySelected(false);
        refine([]);
        return;
      }
    }

    if (event.currentTarget.checked) {
      newSelectedValues.push(value);
    } else {
      const index = newSelectedValues.indexOf(value);
      newSelectedValues.splice(index, 1);
    }

    setSelectedValues(newSelectedValues);
    refine(newSelectedValues);

    // updateFacetsAndMakeAPICall(searchState);
  };
  const handleReset = () => {
    setSelectedValues([]);
    setIndustryCheckBoxValue([]);
    setCategoryCheckBoxValue([]);
    refine([]);
  };

  useEffect(() => {
    if (attribute === "categories.lvl1") {
      setSelectedValues(CategoryCheckBoxValue);
    }
  }, [CategoryCheckBoxValue, attribute]);
  useEffect(() => {
    // console.log("Selected values inside the reset useEffect hook : ",selectedValues);
    // console.log("CategoryCheckBoxvalue inside the reset useEffect hook : ",CategoryCheckBoxValue);
    // Get the Reset button element
    const resetBtn = document.getElementById("ResetBtn");

    if (selectedValues.length > 0 || CategoryCheckBoxValue.length > 0) {
      // console.log("Now showing the reset button")
      resetBtn.style.display = "block";
    }
    if (selectedValues.length === 0 && CategoryCheckBoxValue.length === 0) {
      // console.log("Not not showing the reset button")
      resetBtn.style.display = "none";
    }

    resetBtn.addEventListener("click", handleReset);

    return () => {
      resetBtn.removeEventListener("click", handleReset);
    };
  }, [selectedValues]);

  const handleShowMore = () => {
    setVisibleItemsCount(items.length);
    setIsExpanded(true);
  };

  const handleShowLess = () => {
    setIsExpanded(false);

    setVisibleItemsCount(4);
  };

  const formatLabel = (label) => {
    if (label.includes(">")) {
      const [, text] = label.split(">");
      return text.trim();
    }
    return label;
  };

  // console.log("items : =======================> ",items)

  return (
    <>
      {items.length === 0
        ? ""
        : items
            .filter((item) => item.label !== "0" && item.label !== "1900")
            // .slice(0, showAll ? items.length : 2)
            .slice(0, visibleItemsCount)
            .map((item) => (
              // <div className="checkbox-item" key={item.id}  >
              //     <label className="heading-400-16">{item.label.replace(regex, "")} ({item.count})</label>
              //     <input id={attribute} type="checkbox" name={item.name} value={item.label}
              //         checked={
              //             attribute === "categories.lvl1"
              //                 ? CategoryCheckBoxValue.includes(item.label)
              //                 : selectedValues.includes(item.label)
              //         }
              //         onChange={handleCheckboxChange} />
              // </div>
              <div
                className="checkbox-item"
                // key={item.id}
                key={`${attribute}-${item.label}`}
                style={{ justifyContent: "normal" }}
              >
                <input
                  // id={attribute}
                  id={`${attribute}-${item.label}`}
                  type="checkbox"
                  name={item.name}
                  value={item.label}
                  checked={
                    attribute === "categories.lvl1"
                      ? CategoryCheckBoxValue.includes(item.label)
                      : selectedValues.includes(item.label)
                  }
                  onChange={handleCheckboxChange}
                />

                <label className="heading-400-16  scrollable-text">
                  {/* {console.log("item.label before regex : ",item.label)}
                {item.label.replace(regex, "")}
                {console.log("item.label after regex : ",item.label)} */}
                  {/* {item.label.includes(">")
                  ? item.label
                      .split(">")[1]
                      .trim()
                      .split(" ")
                      .map((word, index) => (
                        <span key={index} className="break-word">
                          {word}
                          <br />
                        </span>
                      ))
                  : item.label.split(" ").map((word, index) => (
                      <span key={index} className="break-word">
                        {word}
                        <br />
                      </span>
                    ))} */}
                  {item.label.includes(">")
                    ? item.label
                        .split(">")[1]
                        .trim()
                        .split(" ")
                        .map((word, index) => (
                          <span key={index} className="break-word">
                            {/* {word.charAt(0).toUpperCase() +
                            word.slice(1).toLowerCase()}
                          <br /> */}
                            {word === "MSME"
                              ? word // Keep MSME as it is
                              : word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()}
                            <br />
                          </span>
                        ))
                    : item.label.split(" ").map((word, index) => (
                        <span key={index} className="break-word">
                          {/* {word.charAt(0).toUpperCase() +
                          word.slice(1).toLowerCase()}
                        <br /> */}
                          {word === "MSME"
                            ? word // Keep MSME as it is
                            : word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()}
                          <br />
                        </span>
                      ))}
                  ({item.count})
                </label>
                {/* <span className="item-count"> ({item.count})</span> */}
              </div>
            ))}
      {/* {items.length > 2 && !showAll && (
           <div >
             <button  onClick={handleLoadMore} className="load-more-button">
              Load More
            </button>

           </div>
          )} */}

      {items.length > visibleItemsCount && (
        <div className="loadmorebuttondiv">
          <button onClick={handleShowMore} className="load-more-button">
            + {items.length - visibleItemsCount} more{" "}
            {/* {items.length - visibleItemsCount === 1 ? "item" : "items"} */}
          </button>
        </div>
      )}

      {isExpanded && (
        <div className="loadmorebuttondiv">
          <button onClick={handleShowLess} className="load-more-button">
            Show Less
          </button>
        </div>
      )}
    </>
  );
};

export default connectRefinementList(ConnectedCustomRefinementListnewLogic);
